import React from "react";
import { useHistory } from "react-router";

const Leadbutton = () => {
  const history = useHistory();
  const roteChange = () => {
    history.push({
      pathname: "/lead",
    });
  };
  return (
    <div>
      <button onClick={() => roteChange()}>Add Lead</button>
    </div>
  );
};

export default Leadbutton;
